import PetsAllowedSvg from "@assets/images/svg/pets-allowed.svg";
import React from "react";
import { View } from "react-native";

export interface PetsAllowedIconProps {
  size?: number;
  color?: string;
}

export function PetsAllowedIcon({
  size = 24,
  color = "#4D4D4D",
}: PetsAllowedIconProps) {
  return (
    <View
      style={{
        width: size,
        height: size,
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <PetsAllowedSvg width={size} height={size} color={color} />
    </View>
  );
}

export default PetsAllowedIcon;
